import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath, faRulerCombined, faMapMarkerAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const PropertyCard = ({ property }) => {
  const { id, title, address, price, type, bedrooms, bathrooms, area, image } = property;

  return (
    <div className="property-card">
      <div className="property-image" style={{ backgroundImage: `url(${image})` }}>
        <div className="property-tag">{type}</div>
        <div className="property-price">${price.toLocaleString()}</div>
        
        <div className="property-content">
          <h3>
            <Link to={`/properties/${id}`}>{title}</Link>
          </h3>
          <div className="property-address">
            <FontAwesomeIcon icon={faMapMarkerAlt} /> {address}
          </div>
          <div className="property-features">
            <div className="feature">
              <FontAwesomeIcon icon={faBed} /> {bedrooms} Beds
            </div>
            <div className="feature">
              <FontAwesomeIcon icon={faBath} /> {bathrooms} Baths
            </div>
            <div className="feature">
              <FontAwesomeIcon icon={faRulerCombined} /> {area} sqft
            </div>
          </div>
          <Link to={`/properties/${id}`} className="view-more-btn">
            View More <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
